// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1ytM_","paramInput":"JobSimulator_paramInput__fYvwe","input":"JobSimulator_input__jYDi1"};